import { Plan } from '../../containers/shared/auth/rules';

/** IB-1899: organisation plans that may manage reporting requirements. The server enforces the same rule. */
export const REPORTING_REQUIREMENTS_PLANS: Plan[] = ['BUSINESS', 'ENTERPRISE'];

export const REPORTING_REQUIREMENTS_UPGRADE_MESSAGE =
  'Reporting requirements are included in the Business and Enterprise plans. Upgrade to set schedules and due dates for your reporters in one place.';

export const hasReportingRequirementsAccess = (plan?: string | null): boolean =>
  !!plan && (REPORTING_REQUIREMENTS_PLANS as string[]).indexOf(plan) !== -1;

/** Owners and admins manage requirements; the server refuses everyone else. */
export const isOrganisationAdmin = (role?: string | null): boolean => /(OWNER|ADMIN)$/.test(String(role || ''));

export const reportingRequirementsPath = (portal: string) => `/${portal}/manage/reporting-requirements`;
